import AxiosController from '@/controllers/AxiosController.js'

const state = {
    newMessagesCount: 0,
    newNotificationsCount: 0
}

const mutations = {
    set_notifications_count(state, payload) {
        state.newMessagesCount = payload.newMessagesCount
        state.newNotificationsCount = payload.newNotificationsCount
    },
    reset_notifications_count(state) {
        state.newNotificationsCount = 0
    }
}

const actions = {
    fetchNotificationsCount({ commit, dispatch }) {
        AxiosController.get('/new-notifications-count').then(res => {
            commit('set_notifications_count', res.data)
        })
    },
    setMessagesAsRead({ commit, dispatch }, payload) {
        AxiosController.post('/mark-as-read', payload).then(res => {
            commit('set_notifications_count', res.data)
        })
    },
    resetNotificationsCount({ commit }) {
        commit('reset_notifications_count')
    }
}

const getters = {
    getMessagesCount: state => state.newMessagesCount,
    getNotificationsCount: state => state.newNotificationsCount
}

export default { state, actions, mutations, getters }
